module.exports = __webpack_public_path__ + "img/tarjeta_ofertas_ahorra_con_tu_taxi.c6a2009c.jpg";